import { forwardRef } from 'react';
import cx from 'clsx';

import styles from '../../card/Card.module.css';

export enum CardWidth {
  full = 'full',
  half = 'half',
  auto = 'auto',
}

export type CardProps = {
  isShadowed?: boolean;
  disabled?: boolean;
  width?: CardWidth;
  className?: string;
  children?: React.ReactNode;
};

// oxlint-disable-next-line prefer-arrow-callback
export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { isShadowed = false, width = CardWidth.full, disabled = false, className = '', children }: CardProps,
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx(styles.Card, styles[`Card--${width}`], className, {
        [styles['Card--shadowed']]: isShadowed,
        [styles['Card--disabled']]: disabled,
      })}
    >
      {children}
    </div>
  );
});
